let CartIcon_quantity = 0;

const calculatCartItems = (data) => {
  try {
    let count = 0;
    data?.cart?.lines?.edges?.forEach((element) => {
      count = count + element?.node?.quantity;
    });
    CartIcon_quantity = count;
    const CartIcon = document.getElementsByTagName("cart-count");
    CartIcon[0].innerText = CartIcon_quantity;
    if (document.getElementById("mini-cart_item-count")) {
      document.getElementById("mini-cart_item-count").innerText =
        CartIcon_quantity === 0 ? "CART" : `${CartIcon_quantity} ITEMS`;
    }
    return count;
  } catch (error) {
    console.log(error);
    return 0;
  }
};
